/* eslint-disable import/order */
import '@src/main/assets/i18n/i18n.ts';
import 'primeicons/primeicons.css';
/* eslint-disable import/order */
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
/* eslint-disable import/order */
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import App from '@src/main/app/App';
import '@src/main/assets/styles/styles.scss';
import { msalConfig } from '@src/main/modules/auth/application/msalConfig';
import { logger } from '@src/main/shared/utils/logger';
import { setupPrimeReactLocale } from '@src/main/shared/utils/primeReactHelpers';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

const storedLang = (localStorage.getItem('currentLanguage') as 'es' | 'en') || 'es';
setupPrimeReactLocale(storedLang);

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        msalInstance.setActiveAccount(response.account);
      } else {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
      }
    })
    .catch((error) => {
      if (error.errorCode !== 'no_token_request_cache_error') {
        logger.error('Redirect promise error:', error);
      }
    })
    .finally(() => {
      createRoot(document.getElementById('root')!).render(
        <StrictMode>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </StrictMode>,
      );
    });
});
